import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import withRouter from "./component/withRouter";
import Layout1 from "./pages/Layout1/Layout1";

//import style
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/pe-icon-7.css";
import "./assets/scss/themes.scss";

const App = () => {
  return (
    <>
      <ToastContainer />

      <Routes>
        <Route path="/" element={<Layout1 />} />
      </Routes>
    </>
  );
};

export default withRouter(App);

// --------------------------------------------------- OLD ----------------------------------

// import React, { Component } from "react";
// import routes from "../src/routes";
// import withRouter from "./component/withRouter";
// import { Route, Routes } from "react-router-dom";

// //import style
// import "./assets/css/pe-icon-7.css";
// import "./assets/scss/themes.scss";

// class App extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {};
//   }
//   render() {
//     return (
//       <React.Fragment>
//         <Routes>
//           {routes.map((route, idx) => (
//             <Route path={route.path} element={route.component} key={idx} />
//           ))}
//         </Routes>
//       </React.Fragment>
//     );
//   }
// }

// export default withRouter(App);
